// extracted by mini-css-extract-plugin
export default {"Logo":"iA6OibwB","xxs":"VA_0s0bF","xs":"QNrQKYt9","sm":"BN159mq1","s":"kvV3YnW6","s2":"fCv9Lby4","m":"HtawQ28l","m2":"azxiQZJL","l":"XslVC2bt"};